var watchlist = {
	createWatchlistAction: "Add Watchlist",
	editWatchlistAction: "Edit Watchlist",
	deleteWatchlistAction: "Delete Watchlist",
	addPosition: "Add Position",
	deletePosition: "Delete Position",
	noWatchlistTitle: "Info",
	noWatchlistMessage: "No watchlist has been created yet. Please click on the \"Add watchlist\" button and fill out the form to create a watchlist.",
	showActions: "Show actions"
};
var en = {
	watchlist: watchlist
};

export { en as default, watchlist };
